import { render, staticRenderFns } from "./detail-address.vue?vue&type=template&id=0fe7cc4f&"
import script from "./detail-address.vue?vue&type=script&lang=js&"
export * from "./detail-address.vue?vue&type=script&lang=js&"
import style0 from "./detail-address.vue?vue&type=style&index=0&id=0fe7cc4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports